<template>
  <div class="main">
    <transition name="fade">
        <material-alert class="font-weight-light" :color="type" dismissible v-if="show">
            <span class="text-sm" v-html="message"></span>
        </material-alert>
    </transition>
  </div>  
</template>

<script>
import MaterialAlert from "../components/MaterialAlert.vue";
export default {
    components: {
        MaterialAlert
    },
    props: {
        type: {
            type: String,
            default: 'success'
        },
        message: {
            type: String,
            default: "<strong>There isn't message</strong>"
        },
        show: {
            type: Boolean,
            default: false
        },
        autoHidden: {
            type: Number,
            default: 7000
        }        
    }

}
</script>
<style scoped>
/* Transições CSS para a classe "fade" */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.main {
    position: fixed;
    width: 100%;
    z-index: 1000;
    top: 0;
}
</style>